<template>
  <div id="page-content">
    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>



// WEBPACK FOOTER //
// PageContent.vue?ff7280f8